import Aircraft from './aircraft.svg'
import styled from 'styled-components'
import { useContext, useEffect, useRef } from 'react'
import GlobalContext from 'Contexts/GlobalContext'
import JET_COLORS from 'Globals/JetColors'
const InfoBoardNormal = ({
  currentTime,
  currentDistance,
  person,
}: {
  currentTime: string
  currentDistance: string
  person: string
}) => {
  const { locale, headerHeight, scrollIndex } = useContext(GlobalContext)
  // convert unix to day in dd.mm.yyyy
  const convertUnixToDate = (unix: number) => {
    const date = new Date(unix * 1000)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
  }
const bgcolor = JET_COLORS[Math.min(Math.max(0,scrollIndex), JET_COLORS.length - 1)]
  return (
    <InfoBoardNormalWrapper headerHeight={headerHeight} show={scrollIndex>=0}>
      <Header backgroundColor={bgcolor}>
        <PersonWrapper>
        <img src={Aircraft} alt='Flugzeug' />
        <span style={{ paddingLeft: '5px' }}>{person}</span>
        </PersonWrapper>
        <Time>{convertUnixToDate(+currentTime)}</Time>
      </Header>
      <InfoBody>
        {/* <Row>
          <Label>{locale.infoBoard.date}:</Label>
          <Time>{convertUnixToDate(+currentTime)}</Time>
        </Row> */}
        <Row>
          <Label>{locale.infoBoard.distance}: {" "}  </Label>
          <Distance >{currentDistance} km</Distance>
        </Row>
      </InfoBody>
    </InfoBoardNormalWrapper>
  )
}
const InfoBoardNormalWrapper = styled.div<{ headerHeight: number, show: boolean }>`
  position: sticky;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.2s ease-in-out;
  top: ${(props) => props.headerHeight}px;
  z-index: 100;
  font-family: var(--font-plex);
  margin-left: auto;
  margin-right: auto;
  backdrop-filter: blur(5px);
  border-radius: 5px;
  max-width: 325px;
  background-color: var(--front-element-background);
`
const PersonWrapper = styled.div`
  display: flex;
  align-items: center;
  `
const Header = styled.div<{backgroundColor: number[]}>`
  color: white;
  text-align: left;
  padding: 0 0.5em;
  font-size: 1em;
  background-color: ${props => `rgba(${props.backgroundColor[0]}, ${props.backgroundColor[1]}, ${props.backgroundColor[2]}, 1)`};
  border-radius: 5px 5px 0 0;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 1em;
    height: 1em;
  }
`
const InfoBody = styled.div`
  padding: 0.25em 0.5em;
  padding-top: 0;
  font-size: 1.5em;
  text-align: right;
`
const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

`
const Label = styled.div`
font-size: 0.4em;
height: 2.2em;

`
const Distance = styled.div`
  font-weight: bold;
  text-align: center;
`

const Time = styled.time`
font-weight:300;`
export default InfoBoardNormal
